<ng-container class="p-2">
    <div class="row p-2">
        <div class="col-8 p=1">
            <div class="row row-cols-sm-auto mb-2">
                @if(userType !== null && isFreightUser()){
                <button
                    class="btn btn-primary reset-button"
                    (click)="updateContainerStatus()"
                    [disabled]="gridSelected.length === 0 || !(statusFlags.none || statusFlags.isPack || statusFlags.isReadyForPickup || statusFlags.isUnpack)"
                >
                    {{ getContainerStatusActionLabel() }}
                </button>

                <button
                    class="btn btn-primary reset-button"
                    (click)="updateContainers()"
                    [disabled]="gridSelected.length === 0"
                >
                    Update Containers
                </button>
                }
                <button
                    class="btn btn-secondary reset-button"
                    (click)="toggleAllGroupings('expand')"
                >
                    Expand All <span><ng-icon
                            size="1em"
                            name="bootstrapArrowsAngleExpand"
                        ></ng-icon></span>
                </button>
                <button
                    class="btn btn-secondary reset-button"
                    (click)="toggleAllGroupings('collapse')"
                >
                    Collapse All <span><ng-icon
                            size="1em"
                            name="bootstrapArrowsAngleContract"
                        ></ng-icon></span>
                </button>
                <span class="align-content-center badge bg-secondary me-3 fs-6 fw-light">
                    Total Items: {{ totalItems }}
                </span>
                <span class="align-content-center badge bg-secondary me-3 fs-6 fw-light">
                    Selected Items: {{ selectedTotalItems }}
                </span>
            </div>
        </div>


        <div class="col-4 ">
            <div class="row">
                <div class="offset-4 col-4 text-end">
                    <button
                        class="btn btn-secondary h-100"
                        (click)="exportToCsv()"
                    >Export</button>
                </div>
                @if(userType === 0){
                <div class="col-4">
                    <button
                        class="btn btn-primary"
                        (click)="createRedirect()"
                    >Create New Job</button>
                </div>
                }
            </div>
        </div>


    </div>
    @if(gridProps && !isInitializing){
    <div class="row">

        <bryntum-grid
            #containerGrid
            [stateId]="this.containerGridStateId"
            [stateful]="gridProps.stateful!"
            [data]="data"
            (onCellClick)="onCellClick($event)"
            [height]="gridHeight"
            [columns]="gridProps.columns!"
            [filterBarFeature]="gridProps.filterBarFeature!"
            [cellEditFeature]="gridProps.cellEditFeature!"
            [excelExporterFeature]="gridProps.excelExporterFeature!"
            [listeners]="gridProps.listeners!"
            [store]="gridProps.store!"
            [selectionMode]="gridProps.selectionMode!"
            [cellMenuFeature]="gridProps.cellMenuFeature!"
            [cellTooltipFeature]="gridProps.cellTooltipFeature!"
            (onSelectionChange)="onGridSelectionChange($event)"
        ></bryntum-grid>
    </div>
    }
</ng-container>
